import React ,{useEffect,useState} from 'react';
import {Box, Button, TextField,Stack,Typography} from '@mui/material';
import {exerciseOptions,fetchData} from '../utils/fetchData';
import HorizontalScrollbar from './HorizontalScrollbar';
const SearchExercises = ({setExercises,bodyPart,setBodyPart}) => { 
  const [search, setSearch] = useState('');
  
  const [bodyParts,setBodyParts]= useState([]);
  useEffect(()=>{
   const fetchExercisesData= async()=>{
    const bodyPartsData= await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList',exerciseOptions);
    setBodyParts(['all', ...bodyPartsData]);
   }
   fetchExercisesData();
  },  []); 

  const handleSearch = async()=>{
    if(search){
      const exercisesData = await fetchData('https://exercisedb.p.rapidapi.com/exercises',exerciseOptions);
      const searchedExercices = exercisesData.filter(
        (exercise)=> exercise.name.toLowerCase().includes(search)||
        exercise.target.toLowerCase().includes(search)||
        exercise.equipment.toLowerCase().includes(search)||
        exercise.bodyPart.toLowerCase().includes(search)
      );
      setSearch('');
      setExercises(searchedExercices);
    
    }
  }
  return (
    <Stack justifyContent="center" p="20px" mt="37px" alignItems="center">
   <Typography fontWeight={700}
   sx={{fontSize:{lg:'44px',xs:'30px'}}} mb="50px" textAlign="center">
    Awesome Exercises You <br/> Should Know
   </Typography>
   <Box position="relative" mb="72px">
    <TextField sx={{input:{
      fontWeight:'700',
      border:'none',
      borderRadius:'4px'},
      width:{lg:'800px',xs:'350px'}, backgroundColor:'#fff' ,borderRadius:"40px"
    }}
     height="76px" value={search}
    onChange={(e)=>setSearch(e.target.value.toLocaleLowerCase())}
    placeholder="Search Exercises" type="text"/>
    <Button sx={{bgcolor:"#ff2625",
    color:"#fff", textTransform:"none", width:{lg:'175px',xs:'14px'}
    , fontSize:{lg:'20px',xs:'14px'}, position:'absolute',height:'56px',right:'0'
    }}
     className="search-btn" onClick={handleSearch} >Search </Button>
   </Box>
   <Box sx={{position:"relative", p:"20px" ,width:'100%'}} >
   <HorizontalScrollbar data={bodyParts}   
    bodyPart={bodyPart} setBodyPart={setBodyPart} isBodyPart
   />
   
   </Box>
    </Stack>
  )
}

export default SearchExercises